import { useUserData } from '../../hooks/useUserData';
import PremiumName from '../ui/PremiumName';

/**
 * ServiceSuggestion - Componente para mostrar sugerencias de servicios con datos de usuario actualizados
 */
const ServiceSuggestion = ({ service, onClick }) => {
  const { userData } = useUserData(service.userId);

  return (
    <button
      onClick={onClick}
      className="w-full flex items-center gap-3 px-3 py-2 hover:bg-gray-100 dark:hover:bg-slate-700 rounded-lg transition-colors text-left"
    >
      {service.media && service.media[0] && (
        <img
          src={typeof service.media[0] === 'string' ? service.media[0] : service.media[0].url}
          alt=""
          className="w-10 h-10 object-cover rounded"
        />
      )}
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-gray-900 dark:text-white truncate">
          {service.caption || 'Sin título'}
        </p>
        <PremiumName
          name={userData?.displayName || service.userName || 'Usuario'}
          isPremium={userData?.isPremium}
          premiumColor={userData?.premiumNameColor}
          nameClassName="text-xs text-gray-500 dark:text-gray-400"
          iconSize="xs"
        />
      </div>
    </button>
  );
};

export default ServiceSuggestion;
